import { getContextColorStyle } from "../utils/colors.utils";
export function useContextColorStyle(contextColorName, colorName, namespace) {
    if (namespace === void 0) { namespace = 't2'; }
    return getContextColorStyle(contextColorName, colorName, namespace);
}
